export const insuredKeys = {
  all: ['insured'] as const,
  byRequest: (idRequest: string | number) => ['insured', idRequest] as const,
};
